/* RESPONSIBLE TEAM: team-inbox-management */
import type AppService from 'embercom/services/app-service';
import ProductSettingsRoute from 'embercom/routes/apps/app/settings/base/product-settings-route';
import type Store from '@ember-data/store';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/-private/transition';
import type TicketStateService from 'embercom/services/ticket-state-service';
import type Session from 'embercom/services/session';
import { hash } from 'rsvp';
import type IntlService from 'embercom/services/intl';
import { CAN_MANAGE_ARTICLES_PERMISSION } from 'embercom/lib/articles/constants';

export default class Tickets extends ProductSettingsRoute {
  @service declare permissionsService: any;
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare store: Store;
  @service declare ticketStateService: TicketStateService;
  @service declare session: Session;

  get app() {
    return this.appService.app;
  }

  get titleToken() {
    return this.intl.t('settings.ticket-data.detail-title');
  }

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);
    this.session.switchWorkspace(this.app.id);
    await this.session.workspace.fetchRequiredAttributes();
    await this.session.workspace.appSettingsLoader.promise;

    let permission = 'can_access_product_settings';
    this.permissionsService.ensurePermissionWhenTransitioning(permission, transition);
  }

  async model() {
    let [canAccessTicketsPortal, ticketTypes, _] = await Promise.all([
      this.permissionsService.currentAdminCan(CAN_MANAGE_ARTICLES_PERMISSION),
      this.fetchTicketTypes(),
      await this.ticketStateService.setup(),
    ]);

    return hash({
      ticketTypes: ticketTypes.toArray(),
      canAccessTicketsPortal,
      appSettings: this.session.workspace.appSettingsLoader.value,
    });
  }

  async fetchTicketTypes() {
    return this.store.findAll('inbox/ticket-type');
  }
}
